import * as React from 'react';
import { Card, CardContent, Box } from '@mui/material';
import { ShiftTable } from './ShiftTable';
import { WeeklyGroup } from '@AMIEWEB/NewOrder/types';
import { missingField } from 'app/constants';
import { useWeeklyGrossPayStyles } from './weeklyGrossPayStyles';
import { CustomTooltip } from '@AMIEWEB/Common';

export const WeeklyGrossPayCard: React.FC<{
  group: WeeklyGroup;
  idx: number;
  count: number;
}> = ({ group, idx, count }) => {
  const { classes } = useWeeklyGrossPayStyles();
  const [isHovered, setIsHovered] = React.useState<boolean>(false);

  return (
    <>
      <Box className={classes.tableCardContainer}>
        <Box className={classes.headerBox}>
          <CustomTooltip
            open={isHovered}
            placement="bottom"
            arrow={true}
            tooltipContent={`${group.discipline} - ${group.specialty}${group.subSpecialty ? " - " + group.subSpecialty : ""}`}
          >
            <span onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
              {group.skillset || missingField}
            </span>
          </CustomTooltip>
        </Box>

        <ShiftTable rows={group.items} />
      </Box>
    </>
  );
};
